export default __webpack_public_path__ + "static/media/wrong.8e2ad3b1.mp3";